var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"en-user-logo",style:(_vm.bindStyle)},[(_vm.icon)?_c('en-icon',{attrs:{"name":_vm.icon,"size":_vm.iconSize}}):(!_vm.calculatedImageUrl || _vm.calculatedImageUrl.length === 0)?_c('span',[_vm._v(_vm._s(_vm.showName))]):_c('el-image',{staticClass:"image",attrs:{"src":_vm.calculatedImageUrl,"fit":"fill"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }